import * as yup from 'yup'

export const selectCategoryScheme = yup.object().shape({
    category: yup.string().required('Pole jest wymagane')
})